import { merge } from 'lodash';
import { Fab } from './Fab';
import { Button } from './Button';
import { IconButton } from './IconButton';
import { ButtonGroup } from './ButtonGroup';
import { ToggleButton } from './ToggleButton'; // ----------------------------------------------------------------------

export var Buttons = function Buttons(_ref) {
  var theme = _ref.theme;
  return merge(Fab({
    theme: theme
  }), Button({
    theme: theme
  }), IconButton({
    theme: theme
  }), ButtonGroup({
    theme: theme
  }), ToggleButton({
    theme: theme
  }));
};